import BannerStock from 'assets/png/hav-stock-2.png'

export const slides = [
  {
    description:
      'Buscando facilitar o acesso aos nossos produtos, criamos um espaço exclusivo para você. Confira!',
    image: BannerStock,
    title: 'Portal de Vendas',
  },
]
